
import React, { Component } from 'react';
// import {  Text, View, TouchableOpacity} from 'react-native';
// import { StackNavigator } from 'react-navigation';
// import VersionNumber from 'react-native-version-number';
import constants from "../constants"
import API from "../API"

//type Props = {};
export default class About extends Component<{}> {
  static navigationOptions = {
    headerStyle: {
      backgroundColor: 'tranparent',
    }
  };

  constructor(props) {
    super(props);

    this.aboutHtml = null;

    /* fetch news page from wordpress */
    API.instance.fetchFromApi(constants.URL.aboutUrl)
      .then((response) => {
        if (!response) throw new Error("no data");
        return response.text()
      })
      .then(text => {
        this.aboutHtml = text;
        this.forceUpdate();
      }).catch(error => {
        console.error(error)
      });
  }

  render() {

    return (
      <div className="flex-container">
        <div id="about" dangerouslySetInnerHTML={{ __html: this.aboutHtml }}></div>
      </div>
    );

  }
}